// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__EKNL-","right":"styles_right__1UqFe"};